import { Table, Tag } from 'antd';
import { CompanyTransfer, eldBrandLabel } from '../../../../../../API/TT_ELD/companyTransfer';
import { useTransferHistory } from '../../../../../../Hooks/TT_ELD/CompanyTransfer';
import { eldTypeLabel, formatDate, TransferStatusTag } from './transferLabels';

const columns = [
  {
    title: 'Direction',
    dataIndex: 'direction',
    key: 'direction',
    render: (direction: CompanyTransfer['direction']) =>
      direction === 'out' ? <Tag color="volcano">Out</Tag> : <Tag color="green">In</Tag>,
  },
  {
    title: 'From → To',
    key: 'route',
    render: (transfer: CompanyTransfer) => {
      const type = transfer.direction === 'out' ? eldTypeLabel(transfer.targetLegal) : '';
      return `${eldBrandLabel(transfer.sourceEld)} → ${eldBrandLabel(transfer.targetEld)}${type ? ` (${type})` : ''}`;
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status: CompanyTransfer['status']) => <TransferStatusTag status={status} />,
  },
  { title: 'Description', dataIndex: 'description', key: 'description', render: (text?: string | null) => text || '-' },
  { title: 'Started', dataIndex: 'startedAt', key: 'startedAt', render: formatDate },
  { title: 'Finished', dataIndex: 'finishedAt', key: 'finishedAt', render: formatDate },
];

const TransferHistory = ({ companyId }: { companyId: string }) => {
  const { data, isLoading } = useTransferHistory(companyId);

  return (
    <Table
      size="small"
      rowKey="migrationId"
      loading={isLoading}
      dataSource={data ?? []}
      columns={columns}
      pagination={(data?.length ?? 0) > 10 ? { pageSize: 10, showSizeChanger: false } : false}
      scroll={{ x: 'max-content' }}
      locale={{ emptyText: 'This company has never been transferred' }}
    />
  );
};

export default TransferHistory;
